<template>
    <div class="zoezi-text-editor">
        <editor-menu-bar :editor="editor" v-slot="{ commands, isActive, getMarkAttrs, focused }" v-if="!bubble">
            <div
                class="menubar is-hidden"
                :class="{ 'is-focused': focused }"
            >
                <form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
                    <input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
                    <button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button">
                        <v-icon>mdi-delete</v-icon>
                    </button>
                </form>
                <v-btn
                    v-for="level in headingLevels" :key="level"
                    class="menubar__button"
                    :class="{ 'is-active': isActive.heading({ level }) }"
                    @click="commands.heading({ level })"
                >
                    <v-icon :color=" isActive.heading({ level }) ? 'primary' : undefined">{{`mdi-format-header-${level}`}}</v-icon>
                </v-btn>

                <v-btn
                    class="menubar__button"
                    :class="{ 'is-active': isActive.bold() }"
                    @click="commands.bold"
                >
                    <v-icon :color="isActive.bold() ? 'primary' : undefined">mdi-format-bold</v-icon>
                </v-btn>

                <v-btn
                    class="menubar__button"
                    :class="{ 'is-active': isActive.italic() }"
                    @click="commands.italic"
                >
                    <v-icon :color="isActive.italic() ? 'primary' : undefined">mdi-format-italic</v-icon>
                </v-btn>

                <v-btn
                    class="menubar__button"
                    :class="{ 'is-active': isActive.underline() }"
                    @click="commands.underline"
                >
                    <v-icon :color="isActive.underline() ? 'primary' : undefined">mdi-format-underline</v-icon>
                </v-btn>

                <v-btn
                    class="menubar__button"
                    :class="{ 'is-active': isActive.link() }"
                    @click="showLinkMenu(getMarkAttrs('link'))"
                >
                    <v-icon :color="isActive.link() ? 'primary' : undefined">mdi-link-variant</v-icon>
                </v-btn>

                <v-btn
                    class="menubar__button"
                    :class="{ 'is-active': isActive.bullet_list() }"
                    @click="applyList(commands, 'bullet_list')"
                >
                    <v-icon :color="isActive.bullet_list() ? 'primary' : undefined">mdi-format-list-bulleted</v-icon>
                </v-btn>

                <v-btn
                    class="menubar__button"
                    :class="{ 'is-active': isActive.ordered_list() }"
                    @click="applyList(commands, 'ordered_list')"
                >
                    <v-icon :color="isActive.ordered_list() ? 'primary' : undefined">mdi-format-list-numbered</v-icon>
                </v-btn>

            </div>
        </editor-menu-bar>

        <editor-menu-bubble :editor="editor" :keep-in-bounds="keepInBounds" v-slot="{ commands, isActive, getMarkAttrs, menu }" v-else>
            <div
                class="menububble"
                :class="{ 'is-active': menu.isActive }"
                :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
            >
                <form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
                    <v-text-field v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
                    <button class="menububble__button" @click="setLinkUrl(commands.link, null)" type="button">
                        <v-icon>mdi-delete</v-icon>
                    </button>
                </form>
                <v-btn
                    v-for="level in headingLevels" :key="level"
                    class="menububble__button"
                    color="primary"
                    small
                    :class="{ 'is-active': isActive.heading({ level }) }"
                    :outlined="!isActive.heading({ level })"
                    @click="commands.heading({ level })"
                >
                    <v-icon>{{`mdi-format-header-${level}`}}</v-icon>
                </v-btn>

                <v-btn
                    small
                    color="primary"
                    class="menububble__button"
                    :class="{ 'is-active': isActive.bold() }"
                    :outlined="!isActive.bold()"
                    @click="commands.bold"
                >
                    <v-icon>mdi-format-bold</v-icon>
                </v-btn>

                <v-btn
                    small
                    color="primary"
                    class="menububble__button"
                    :class="{ 'is-active': isActive.italic() }"
                    :outlined="!isActive.italic()"
                    @click="commands.italic"
                >
                    <v-icon>mdi-format-italic</v-icon>
                </v-btn>

                <v-btn
                    small
                    color="primary"
                    class="menububble__button"
                    :class="{ 'is-active': isActive.underline() }"
                    :outlined="!isActive.underline()"
                    @click="commands.underline"
                >
                    <v-icon>mdi-format-underline</v-icon>
                </v-btn>

                <v-btn
                    small
                    color="primary"
                    class="menububble__button"
                    :class="{ 'is-active': isActive.link() }"
                    :outlined="!isActive.link()"
                    @click="showLinkMenu(getMarkAttrs('link'))"
                >
                    <v-icon>mdi-link-variant</v-icon>
                </v-btn>

                <v-btn
                    small
                    color="primary"
                    class="menububble__button"
                    :class="{ 'is-active': isActive.bullet_list() }"
                    :outlined="!isActive.bullet_list()"
                    @click="applyList(commands, 'bullet_list')"
                >
                    <v-icon>mdi-format-list-bulleted</v-icon>
                </v-btn>

                <v-btn
                    small
                    color="primary"
                    class="menububble__button"
                    :class="{ 'is-active': isActive.ordered_list() }"
                    :outlined="!isActive.ordered_list()"
                    @click="applyList(commands, 'ordered_list')"
                >
                    <v-icon>mdi-format-list-numbered</v-icon>
                </v-btn>

            </div>
        </editor-menu-bubble>
        <editor-content :editor="editor" />
    </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBubble, EditorMenuBar } from 'tiptap'
import { Heading, Bold, Italic, Underline, ListItem, OrderedList, BulletList, Placeholder, HardBreak, Link } from 'tiptap-extensions'
import { sanitizeHtml } from '../plugins/safeHtml.js'
export default {
    name: 'zoezi-text-editor',

    components: {
        EditorContent,
        EditorMenuBubble,
        EditorMenuBar
    },

    props: ['value', 'placeholder', 'bubble', 'min-height'],

    data: () => ({
        editor: null,
        keepInBounds: true,
        headingLevels: 3,
        // Last value we emitted (already sanitized). Used to ignore the echo
        // back through v-model so we don't reset the cursor on every keystroke.
        lastEmitted: null,
        linkUrl: null,
        linkMenuIsActive: false,
    }),

    methods: {
        showLinkMenu(attrs) {
            this.linkUrl = attrs.href
            this.linkMenuIsActive = true
            this.$nextTick(() => {
                this.$refs.linkInput.focus()
            })
        },
        hideLinkMenu() {
            this.linkUrl = null
            this.linkMenuIsActive = false
        },
        setLinkUrl(command, url) {
            command({ href: this.sanitizeLinkUrl(url) })
            this.hideLinkMenu()
        },
        sanitizeLinkUrl(url) {
            if (!url) return null
            // Strip whitespace (tabs/newlines) browsers ignore, so a hidden
            // scheme can't slip past the check.
            const cleaned = url.replace(/\s/g, '').toLowerCase()
            if (/^(?:javascript|data|vbscript):/i.test(cleaned)) return null
            return url.trim() || null
        },
        applyList(commands, listType) {
            // If cursor is inside a heading, convert to paragraph first,
            // since headings cannot be inside list items.
            const { $from } = this.editor.state.selection;
            if ($from.parent.type.name === 'heading') {
                commands.paragraph();
            }
            commands[listType]();
        }
    },

    watch: {
        value(newVal) {
            // Skip our own sanitized echo (newVal === lastEmitted); only
            // reset content on genuinely external value changes.
            if (this.editor && newVal !== this.editor.getHTML() && newVal !== this.lastEmitted) {
                this.editor.setContent(newVal || '');
            }
        }
    },

    created() {
        let levels = [];
        for (let i=0; i < this.headingLevels; ++i) {
            levels.push(i+1);
        }
        this.editor = new Editor({
            content: this.value,
            extensions: [
                new Heading({levels}),
                new HardBreak(),
                new Bold(),
                new Italic(),
                new Underline(),
                new Link(),
                new OrderedList(),
                new BulletList(),
                new ListItem(),
                this.placeholder ? new Placeholder({emptyNodeText: this.placeholder, emptyEditorClass: 'is-editor-empty'}) : null
            ].filter(x => x),
            onUpdate: ({ getHTML }) => {
                // Sanitize at the source so stored content never carries
                // javascript:/data: hrefs or event handlers from the editor.
                const html = sanitizeHtml(getHTML());
                this.lastEmitted = html;
                this.$emit('input', html);
            }
        });
    },

    beforeDestroy() {
        this.editor.destroy()
    }
}
</script>
